<template>
  <main :class="$style.mainContent">
    <slot />
  </main>
</template>

<style lang="scss" module>
  .mainContent {
    background: $color-white;
    border-radius: $border-radius;
  }
</style>
